import React, {useEffect, useState} from 'react';
import axios from "axios";
import {IntlProvider} from 'react-intl';
import PropTypes from "prop-types";
import {connect} from "react-redux";

import parseTableToTranslates from "./parseTableToTranslates";
import {hardCodeIsAmericanImport, hardCodeIsLowes, hardCodeIsMcDermott} from "../constants/fabricatorHardcode";

let translatesPath = document.location.port === "9005" ? "./translates" : "/content/views/dashboard/translates";

const getCustomJson = async (fileName = "") => {
  try {
    const customJsonResponse = await axios.get(`${translatesPath}/custom/${fileName}.json?v=1.0.0`);
    if (customJsonResponse && customJsonResponse.data) {
      return customJsonResponse.data
    }
    return {}
  } catch (e) {
    console.log("couldn't set translate", e);
    return {}
  }
}

const TranslatesProvider = (props) => {
  const {language, subDomain, children} = props;
  const [translations, setTranslations] = useState(null);
  const [renderLanguage, setRenderLanguage] = useState(language);
  const [currentSubDomain, setCurrentSubdomain] = useState("");

  const loadTranslates = async () => {
    const responseMain = await axios.get(translatesPath + "/translates_v5.csv?v=2.0.3");
    const trans = parseTableToTranslates(responseMain);
    let customTranslates = {};
    if (language === "en-AU") {
      trans["en-AU"] = {...trans["en-US"]}
      customTranslates = await getCustomJson( "en-AU");
    }
    if (hardCodeIsLowes(subDomain)) {
      customTranslates = await getCustomJson( "Lowes");
    } else if (hardCodeIsAmericanImport(subDomain)) {
      customTranslates = await getCustomJson( "Lixil");
    } else if (hardCodeIsMcDermott(subDomain)) {
      customTranslates = await getCustomJson( "McDermott");
    }

    setTranslations({...trans[language], ...customTranslates[language]});
    // console.log("all translates:", trans);
    // console.log("current translates:", trans[translationColumn]);
    setRenderLanguage(language); // change frontend after load
  }

  useEffect(() => {
    loadTranslates().catch(console.error);
  }, [language]);

  useEffect(() => {
    if (currentSubDomain) { // if subdomain is changed - load translates again (fabricator change issue)
      loadTranslates().catch(console.error);
    }
    setCurrentSubdomain(subDomain);
  }, [subDomain])

  const styles = {
    width: "100%",
    height: "100%",
    margin: 0,
    padding: 0
  }
  if (!translations) {
    return (
      <div className={"app-content-wrapper"} style={styles}>
        <div className="ui-loader"/>
      </div>
    )
  }

  return (
    <IntlProvider locale={renderLanguage}
                  messages={translations}
                  // defaultLocale={AVAILABLE_LANGUAGES[0]}
                  onError={(error) => console.info(error)}>
      {children}
    </IntlProvider>
  )

}

TranslatesProvider.propTypes = {
  locale: PropTypes.string
};

const mapStateToProps = (store) => {
  const {auth, asCustomer} = store;
  return {
    language: store.dashboardState.language,
    subDomain: asCustomer.data && asCustomer.data.subDomain ? asCustomer.data.subDomain : auth.subDomain,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(TranslatesProvider);

